import { ActivityCard, FormLabel, Heading, Loader } from "@/components";
import useCollection from "./useClearing";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui";
import { yearOptions } from "@/lib/utils";

const Clearing = () => {
  const {
    communityData,
    clearingCards,
    onAccordionChange,
    openTabs,
    onExpandCollapse,
    onCreateCardClick,
    onCardClick,
    breadcrumbData,
    onBackClick,
    isClearingStatLoading,
    onYearChange,
    currentFinanceYear,
  } = useCollection();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title="Clearing"
            breadcrumbData={breadcrumbData}
            showBack
            onBackClick={onBackClick}
          />
        </div>
      </div>

      {isClearingStatLoading ? (
        <Loader />
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-[20px]">
            <h2 className="text-lg font-[600] items-start flex">
              {communityData?.communityName}
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-4 col-span-2 justify-end gap-[20px]">
              <div></div>
              <div></div>
              <Button onClick={onExpandCollapse}>
                {openTabs?.length ? "Collapse All" : "Expand All"}
              </Button>
              <div className="relative">
                <FormLabel>Year</FormLabel>
                <Select onValueChange={onYearChange}>
                  <SelectTrigger className="w-full bg-white">
                    <SelectValue
                      placeholder={
                        yearOptions(5)?.find(
                          (data: any) => data.value == currentFinanceYear
                        )?.label
                      }
                    />
                  </SelectTrigger>
                  <SelectContent>
                    {yearOptions(5)?.map((data: any) => (
                      <SelectItem key={data?.value} value={data?.value}>
                        {data?.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>

          <div className="grid grid-col-1 gap-[20px] mt-[20px]">
            <Accordion
              type="multiple"
              value={openTabs}
              onValueChange={onAccordionChange}
            >
              {/* Clearing Documents */}
              <AccordionItem
                value="clearing"
                className="bg-white px-5 rounded-lg shadow-md"
              >
                <AccordionTrigger className="cursor-pointer">
                  Clearing Documents
                </AccordionTrigger>
                <AccordionContent>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] py-4">
                    {clearingCards?.map((data, index) => {
                      return (
                        <ActivityCard
                          key={`clearing-${index}`}
                          isCreate={data.id == "create"}
                          isSummary={data.id == "summary"}
                          isValueObject={data.id == "valueObject"}
                          isTitleOnly={data.id == "titleOnly"}
                          hideCount={(data as any).hideCount || false}
                          data={data}
                          access={!!(data as any)?.access}
                          onCardClick={
                            data.id == "create" && data?.link
                              ? onCreateCardClick(data?.link)
                              : onCardClick(data?.link)
                          }
                        />
                      );
                    })}
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </>
      )}
    </div>
  );
};

export default Clearing;
